// extracted by mini-css-extract-plugin
export var table = "_y2-0";